import type { ResourceProps } from 'react-admin';
import DescriptionIcon from '@mui/icons-material/Description';
import { type ComponentType, lazy } from 'react';

const AsyncPageList = lazy(() => import('./list'));
// const AsyncPageShow = lazy(() => import('./show'));
const AsyncPageCreate = lazy(() => import('./create'));
const AsyncPageEdit = lazy(() => import('./edit'));

export default {
  list: AsyncPageList as ComponentType<any>,
  // show: AsyncPageShow as ComponentType<any>,
  create: AsyncPageCreate as ComponentType<any>,
  edit: AsyncPageEdit as ComponentType<any>,
  icon: DescriptionIcon as ComponentType<any>,
} as ResourceProps;
